import { render } from "./DropdownContacts.vue?vue&type=template&id=71aaff8f"
import script from "./DropdownContacts.vue?vue&type=script&lang=ts"
export * from "./DropdownContacts.vue?vue&type=script&lang=ts"

import "./DropdownContacts.vue?vue&type=style&index=0&id=71aaff8f&lang=scss"
script.render = render

export default script